import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { GraphqlService } from 'src/app/services/graphql.service';
import { ProviderTransactions } from 'src/app/models/provider';
import { ApolloError } from '@apollo/client/errors';

@Component({
  selector: 'app-provider-transactions',
  templateUrl: './provider-transactions.component.html',
  styleUrls: ['./provider-transactions.component.css']
})
export class ProviderTransactionsComponent implements OnInit {

  Transactions: any[] = [];  // Array to store transaction data
  total_records: number = 0; // Total number of records

  constructor(
    private readonly graphqlService: GraphqlService,
    private readonly changeDetector: ChangeDetectorRef
  ) { }
  providertransactions: ProviderTransactions = new ProviderTransactions();
  invoicePdf: ProviderTransactions = new ProviderTransactions();

  ngOnInit(): void {
    this.getProviderTransactions(); 
  }

  getProviderTransactions(): void {
    this.graphqlService.fetchProviderLicenseTransactions()
      .subscribe((result) => {
        if (result.data && result.data.fetchProviderLicenseTransactions) {
          this.Transactions = result.data.fetchProviderLicenseTransactions;
          this.Transactions = [...this.Transactions];
          this.total_records = this.Transactions.length;
        }
      }, (error: ApolloError) => {
        if (error.graphQLErrors) {
          for (const graphQLError of error.graphQLErrors) {
            if (graphQLError.extensions.code === 'BAD_REQUEST') {
              const messages: string[] = graphQLError.extensions.originalError.message
              this.providertransactions.create_api_result.ServerError.error = messages.join(",")
              this.providertransactions.create_api_result.ServerError.message = messages
              this.providertransactions.create_api_result.ServerError.statusCode = 400
            }
            else if (graphQLError.extensions.code === 'INTERNAL_SERVER_ERROR') {
              const messages: string[] = [graphQLError.message]
              this.providertransactions.create_api_result.ServerError.error = messages.join(",")
              this.providertransactions.create_api_result.ServerError.message = messages
              this.providertransactions.create_api_result.ServerError.statusCode = 400
            }
            else {
              const messages: string[] = ['Something went wrong!!']
              this.providertransactions.create_api_result.ServerError.error = null
              this.providertransactions.create_api_result.ServerError.message = messages
              this.providertransactions.create_api_result.ServerError.statusCode = 500
            }
          }
        } else if (error.networkError) {
          const messages: string[] = ['Network Error']
          this.providertransactions.create_api_result.ServerError.error = messages.join(",")
          this.providertransactions.create_api_result.ServerError.message = messages
          this.providertransactions.create_api_result.ServerError.statusCode = 500
        }

        this.providertransactions.create_api_result.PromiseResult.success = false;
        this.providertransactions.create_api_result.Posting = false;
        this.changeDetector.detectChanges();
      });
  }

  getInvoice(invoiceId: string) {
    this.graphqlService.fetchInvoicePDF(invoiceId).subscribe((result) => {
        if (result && result.data && result.data.fetchInvoicePDF) {
            window.open(result.data.fetchInvoicePDF, '_blank');
        } else {
            console.error('No Invoice URL returned');
        }
    }, (error: ApolloError) => {
      if (error.graphQLErrors) {
        for (const graphQLError of error.graphQLErrors) {
          if (graphQLError.extensions.code === 'BAD_REQUEST') {
            const messages: string[] = graphQLError.extensions.originalError.message
            this.invoicePdf.create_api_result.ServerError.error = messages.join(",")
            this.invoicePdf.create_api_result.ServerError.message = messages
            this.invoicePdf.create_api_result.ServerError.statusCode = 400
          }
          else if (graphQLError.extensions.code === 'INTERNAL_SERVER_ERROR') {
            const messages: string[] = [graphQLError.message]
            this.invoicePdf.create_api_result.ServerError.error = messages.join(",")
            this.invoicePdf.create_api_result.ServerError.message = messages
            this.invoicePdf.create_api_result.ServerError.statusCode = 400
          }
          else {
            const messages: string[] = ['Something went wrong!!']
            this.invoicePdf.create_api_result.ServerError.error = null
            this.invoicePdf.create_api_result.ServerError.message = messages
            this.invoicePdf.create_api_result.ServerError.statusCode = 500
          }
        }
      } else if (error.networkError) {
        const messages: string[] = ['Network Error']
        this.invoicePdf.create_api_result.ServerError.error = messages.join(",")
        this.invoicePdf.create_api_result.ServerError.message = messages
        this.invoicePdf.create_api_result.ServerError.statusCode = 500
      }

      this.invoicePdf.create_api_result.PromiseResult.success = false;
      this.invoicePdf.create_api_result.Posting = false;
      this.changeDetector.detectChanges();
    });
}

}
